import { render, staticRenderFns } from "./CommunityOverviewCard.vue?vue&type=template&id=a37639d2"
import script from "./CommunityOverviewCard.vue?vue&type=script&lang=js"
export * from "./CommunityOverviewCard.vue?vue&type=script&lang=js"
import style0 from "./CommunityOverviewCard.vue?vue&type=style&index=0&id=a37639d2&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports